export default [
  'left',
  'center',
  'right',
  'justify'
];
